import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import { ThunkDispatch } from "redux-thunk";

import CreateApiModule from "@/redux/create-api-module";
import { refetch as refetchAddressbook } from "@/redux/modules/api/data/addressbook/addressbook.module";
import {
    IState,
    TApiAction,
    TExtendedApiAction,
    TExtraThunkArgs
} from "@/redux/store.types";
import { Config } from "@/utils/config.utils";

import { $AddressModuleName, CreateAddressRequest } from "./address.types";

const { actions, constants } = CreateApiModule(
    $AddressModuleName,
    ({ url }) => url
);

export const create =
    (addresses: CreateAddressRequest) =>
    async (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        const action = await dispatch(
            actions.load<
                TExtendedApiAction<{ addresses: Array<CloudCustomerAddress> }>
            >(
                {
                    path: {
                        url: `/customerservice/${Config.general.basestore}/customers/addresses`
                    },
                    data: {
                        addresses
                    }
                },
                "POST",
                true
            )
        );
        if (action.type === constants.SUCCESS) {
            await dispatch(refetchAddressbook());
        }

        return action;
    };

export const update =
    (
        id: string,
        addressing: string,
        firstName: string,
        lastName: string,
        country: string,
        city: string,
        street: string,
        box: string,
        number: string,
        zipCode: string,
        validationStatus: AddressValidationStatus,
        defaultDeliveryAddress: boolean = false,
        defaultPaymentAddress: boolean = false
    ) =>
    async (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        const action = await dispatch(
            actions.load(
                {
                    path: {
                        url: `/customerservice/${Config.general.basestore}/customers/addresses`
                    },
                    data: {
                        id,
                        addressing,
                        firstName,
                        lastName,
                        country,
                        city,
                        street,
                        box,
                        number,
                        zipCode,
                        validationStatus,
                        defaultDeliveryAddress,
                        defaultPaymentAddress
                    }
                },
                "PUT",
                true
            )
        );

        if (action.type === constants.SUCCESS) {
            dispatch(refetchAddressbook());
        }
        return Promise.resolve(action);
    };

export const deleteAddress =
    (addressId: string) =>
    async (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        const action = await dispatch(
            actions.load(
                {
                    path: {
                        url: `/customerservice/${Config.general.basestore}/customers/addresses/${addressId}`
                    }
                },
                "DELETE"
            )
        );

        if (action.type === constants.SUCCESS) {
            dispatch(refetchAddressbook());
        }
        return Promise.resolve(action);
    };

export const updateDefaultDelivery =
    (address: any) =>
    async (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        address.defaultDeliveryAddress = true;
        const action = await dispatch(
            actions.load(
                {
                    path: {
                        url: `/customerservice/${Config.general.basestore}/customers/addresses`
                    },
                    data: address
                },
                "PUT"
            )
        );
        if (action.type === constants.SUCCESS) {
            dispatch(refetchAddressbook());
        }
        return Promise.resolve(action);
    };

export const updateDefaultBilling =
    (address: any) =>
    async (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        address.defaultPaymentAddress = true;
        const actio = await dispatch(
            actions.load(
                {
                    path: {
                        url: `/customerservice/${Config.general.basestore}/customers/addresses`
                    },
                    data: address
                },
                "PUT"
            )
        );

        if (actio.type === constants.SUCCESS) {
            dispatch(refetchAddressbook());
        }
        return Promise.resolve(actio);
    };

export const clear = actions.clear;
export const refetch = actions.refetch;
export const APIStatus = constants;
